<template>
  <el-drawer
    :model-value="modelValue"
    title="分支格子 — 查看"
    direction="btt"
    size="82%"
    class="m-branch-view-drawer"
    destroy-on-close
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <div class="m-bv-head">
      <p class="m-bv-line">
        <span>分支合计 <b>{{ fmt(sumBranch) }}</b> 码</span>
        <span class="m-bv-dot">·</span>
        <span>本行库存 <b>{{ fmt(physicalQty) }}</b> 码</span>
      </p>
      <p v-if="showMismatch" class="m-bv-warn">分支与总数不符</p>
      <p v-else-if="enableBranch" class="m-bv-ok">分支合计与库存一致</p>
      <p v-else class="m-bv-muted">未启用分支管理：分支合计按库存显示（视为一卷）</p>
    </div>

    <h4 class="m-bv-sub">分支支数（仅显示有数量的格，按数量从小到大）</h4>
    <div v-if="occupied.length" class="m-bv-occ-grid">
      <div v-for="(it, i) in occupied" :key="`${it.label}-${i}`" class="m-bv-tile">
        <span class="m-bv-tile-pos">{{ it.label }}</span>
        <span class="m-bv-tile-qty">{{ fmt(it.qty) }}</span>
      </div>
    </div>
    <el-empty v-else description="暂无分支数量" :image-size="72" />
  </el-drawer>
</template>

<script setup>
import { computed } from 'vue'
import { sumBranchDetails, occupiedBranchCellsSortedAsc } from '@/utils/materialBatchBranchGrid'

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  branchDetails: { type: [Array, Object], default: null },
  physicalQty: { type: [Number, String], default: 0 },
  enableBranch: { type: Boolean, default: false }
})

defineEmits(['update:modelValue'])

const sumBranch = computed(() => sumBranchDetails(props.branchDetails))
const physical = computed(() => Number(props.physicalQty) || 0)
const showMismatch = computed(() => {
  if (!props.enableBranch) return false
  return Math.abs(sumBranch.value - physical.value) > 0.01
})

const occupied = computed(() => occupiedBranchCellsSortedAsc(props.branchDetails))

function fmt (v) {
  if (v == null || v === '') return '0'
  const n = Number(v)
  if (!Number.isFinite(n)) return String(v)
  const r = Math.round(n * 10) / 10
  return Number.isInteger(r) ? String(r) : r.toFixed(1).replace(/\.0$/, '')
}
</script>

<style scoped>
.m-branch-view-drawer :deep(.el-drawer__body) {
  padding: 12px 14px 20px;
  overflow: auto;
}

.m-bv-head {
  margin-bottom: 14px;
}

.m-bv-line {
  margin: 0 0 8px;
  font-size: 14px;
  color: #1e293b;
}

.m-bv-dot {
  margin: 0 6px;
  color: #94a3b8;
}

.m-bv-warn {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #ef4444;
}

.m-bv-ok {
  margin: 0;
  font-size: 13px;
  color: #16a34a;
}

.m-bv-muted {
  margin: 0;
  font-size: 13px;
  color: #64748b;
}

.m-bv-sub {
  margin: 16px 0 8px;
  font-size: 14px;
  color: #334155;
}

.m-bv-occ-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(5.25rem, 1fr));
  gap: 10px;
  margin-bottom: 8px;
}

.m-bv-tile {
  background: linear-gradient(145deg, #f8fafc, #eef2ff);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 8px;
  text-align: center;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.m-bv-tile-pos {
  display: block;
  font-size: 12px;
  color: #64748b;
  margin-bottom: 4px;
  font-weight: 600;
}

.m-bv-tile-qty {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}
</style>
